/**
 * 选择SKU子组件
 */
import React, { useEffect, useState } from 'react';
import { Select, Icon, Tab, Form, Input, Button, Table } from '@alifd/next';
import LzPagination from '@/components/common/LzPagination';
import LzMsg from '@/components/common/LzMsg';
import Tips from '@/components/UI/Tips';
import styles from './index.module.scss';

const defaultTrigger = <Icon type="help" size="xs" />;
const levelList = [
  { value: 0, label: '请选择' },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
  { value: 9, label: '9' },
  { value: 10, label: '10' },
];

interface Props {
  changeTabProduct?: (num: string) => void;
  searchSku?: (p?: Record<string, any>) => Promise<void>;
  skus?: any[];
  selectSku?: any[];
  supportSku?: number;
  importSkuTip?: string;
  conditions?: Record<string, any>;
  setConditions?: (val: Record<string, any>) => void;
  formData?: Record<string, any>;
  setFormData?: (val: Record<string, any>) => void;
  pageSkuInfo?: Record<string, number>;
  reset?: () => Promise<void>;
  selectSkuIds?: string[];
  importSku?: any[];
  failSku?: number;
  onCloseActive?: () => void;
  saveTable?: () => Promise<void>;
  setSelectSku?: (val: any[]) => void;
}

const SelectSku = ({
  changeTabProduct = () => {},
  searchSku = async () => {},
  skus = [],
  selectSku = [],
  supportSku,
  importSkuTip,
  conditions = {},
  setConditions = () => {},
  formData = {},
  setFormData = () => {},
  pageSkuInfo = { pageNo: 1, pageSize: 10, total: 0 },
  reset = async () => {},
  selectSkuIds = [],
  importSku = [],
  failSku = 0,
  onCloseActive = () => {},
  saveTable = async () => {},
  setSelectSku = () => {},
}: Props): JSX.Element => {
  const [skuIds, setSkuIds] = useState('');

  // 勾选sku
  const changeSkusHandler = (value: string[]): void => {
    value = Array.from(new Set(value)) as string[];
    // 找到未勾选且在已选活动中的项  移除数组
    const arr = skus.filter((item: any) => {
      return value.indexOf(item.skuId) < 0;
    });
    const diff1 = arr.map((t: any) => t.skuId);
    // selectAList里删除  diff1 里有的
    const computedArr = selectSku.filter((r: any) => {
      return diff1.indexOf(r.skuId) < 0;
    });
    // 支持勾選的數量
    if (supportSku && selectSku.length >= supportSku) {
      const saveArr = [...computedArr];
      setSelectSku(saveArr);
      parent.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      LzMsg.error(importSkuTip || '');
      return;
    }
    // 找到本页面且不在已选活动中的项  加入数组
    const diff = value.filter((item: string) => {
      return selectSkuIds.indexOf(item) < 0;
    });
    const items = skus.filter((v: any) => {
      return diff.indexOf(v.skuId) > -1;
    });
    const saveArr = [...items, ...computedArr];
    setSelectSku(saveArr);
  };

  // 清空
  const clearSkus = (): void => {
    setSelectSku([]);
  };

  // 删除某个sku
  const removeSelSku = (index: number): void => {
    setSelectSku(
      selectSku.filter((_e: any, f: number) => f !== index)
    );
  };

  // 点击查询才会改变skuIds的值
  const select = (values: Record<string, any>, err: unknown): void => {
    setConditions(values);
    searchSku({ pageNo: 1, skuIds: values.skuIds });
  };

  return (
    <section
      className={`selectSku ${styles.container} ${
        supportSku && supportSku < pageSkuInfo.pageSize ? 'supportSku' : ''
      }`}
    >
      <div className={styles.formRow}>
        <div>
          <span className={styles.required}>*</span>
          <span className={styles.mr10}>商品分组名称：</span>
          <Input
            placeholder="请输入商品分组名称"
            showLimitHint
            maxLength={24}
            style={{ width: 230 }}
            onChange={(productLineName: string) => setFormData({ ...formData, productLineName })}
            value={(formData as Record<string, any>).productLineName}
          />
        </div>
        <div>
          <span className={`${styles.ml10} ${styles.mr10}`}>商品分组描述：</span>
          <Input
            placeholder="请输入商品分组描述"
            maxLength={32}
            style={{ width: 230 }}
            onChange={(productLineDes: string) => setFormData({ ...formData, productLineDes })}
            value={(formData as Record<string, any>).productLineDes}
          />
        </div>
        <div>
          <span className={`${styles.ml10} ${styles.mr10}`}>商品分组类型：</span>
          <Input
            placeholder="请输入商品分组类型"
            maxLength={32}
            style={{ width: 230 }}
            onChange={(productLineType: string) => setFormData({ ...formData, productLineType })}
            value={(formData as Record<string, any>).productLineType}
          />
        </div>
      </div>

      <div className={styles.levelRow}>
        <span className={`${styles.mr10} ${styles.levelLabel}`}>商品分组级别：</span>
        <Select
          placeholder="请选择商品分组级别"
          style={{ width: 230 }}
          onChange={(productLineLv: number) => setFormData({ ...formData, productLineLv })}
          value={(formData as Record<string, any>).productLineLv}
        >
          {levelList.map((i) => (
            <Select.Option value={i.value} key={i.label}>{i.label}</Select.Option>
          ))}
        </Select>
      </div>

      <div className={`${styles.selectGoods} ${styles.selectGoodsMargin}`}>
        <Tab shape="wrapped" size="small" onChange={changeTabProduct as (key: string) => void}>
          <Tab.Item title="按SKU选择" key="1-1">
            <div className={styles.searchFormWrap}>
              <Form className="search-conditions" inline>
                <Form.Item className="item" label="SKU ID：">
                  <Input name="skuIds" placeholder="请输入SKUID" style={{ width: 300 }} />
                </Form.Item>
                <Form.Item className="item allBtns formAlignLeft">
                  <Form.Submit type="secondary" onClick={select}>查询</Form.Submit>
                  <Form.Reset type="normal" className={styles.ml10} onClick={reset}>重置</Form.Reset>
                </Form.Item>
              </Form>
            </div>
            <Table
              primaryKey="skuId"
              rowSelection={{
                selectedRowKeys: selectSkuIds,
                onChange: (value: string[]) => changeSkusHandler(value),
              }}
              dataSource={skus}
              fixedHeader
              className={styles.tableWrap}
            >
              <Table.Column align="center" title="SKU ID" dataIndex="skuId" />
            </Table>
            <div className={styles.paginationWrap}>
              <LzPagination pageInfo={pageSkuInfo} onChange={searchSku as (pages: Record<string, number>) => Promise<void>} />
            </div>
          </Tab.Item>
          <Tab.Item title="导入商品" key="1-2">
            <div className={styles.importSection}>
              <Tips content="使用导入商品功能，快速选择多个商品" />
              <Input.TextArea
                className={styles.textareaMargin}
                placeholder="多个SKU可以一行一个或逗号分隔"
                rows={25}
                value={skuIds}
                style={{
                  width:'100%'
                }}
                onChange={(value: string) => setSkuIds(value)}
              />
              <p>成功导入 {importSku.length} 个，失败{failSku}个</p>
              <Button
                type="secondary"
                onClick={() => searchSku({ skuIds: skuIds.replace(/[\r\n，]/g, ','), type: 1 })}
              >
                确认导入
              </Button>
            </div>
          </Tab.Item>
          <Tab.Item title={`已选择(${selectSku.length}个)`} key="1-3">
            <div
              style={{
                width:'100%'
              }}
            >
              <div className={styles.clearBtnArea}>
                <Button onClick={clearSkus}>清空</Button>
              </div>
              <div className="skuContains">
                <Table
                  primaryKey="skuId"
                  dataSource={selectSku}
                  fixedHeader
                  className="selectTable"
                >
                  <Table.Column
                    title="选择商品"
                    cell={(value, _index, info: any) => (
                      <div className={styles.productCell}>
                        <img className={styles.productImg} src={info.imagePath} alt="" />
                        <div className={styles.productName}><p>{info.name}</p></div>
                      </div>
                    )}
                  />
                  <Table.Column width={180} align="center" title="SKU ID" dataIndex="skuId" />
                  <Table.Column
                    width={120}
                    align="center"
                    title="价格"
                    dataIndex="price"
                    cell={(value, _index, tableData: any) => (
                      <div>{(+tableData.price).toFixed(2)}</div>
                    )}
                  />
                  <Table.Column
                    lock="right"
                    width={100}
                    align="center"
                    title="操作"
                    cell={(value, index, tableData: any) => (
                      <div><Button type="primary" text onClick={() => removeSelSku(index)}>删除</Button></div>
                    )}
                  />
                </Table>
              </div>
            </div>
          </Tab.Item>
        </Tab>
      </div>
      <hr />
      <div className={styles.bottomBar}>
        <Button className={`${styles.btnMarginR} ${styles.w88}`} onClick={onCloseActive}>取消</Button>
        <Button type="primary" className={styles.w88} onClick={() => saveTable()}>确认</Button>
      </div>
    </section>
  );
};

export default SelectSku;
